<template>
	<div class="card" :class="{dark:dark}">
		<div class="card-body" :class="{'stacked' : stacked}">
			<label>{{label}}</label>
			<span class="value">{{value}}</span>
		</div>
	</div>
</template>

<script type="text/javascript">
export default {
	name: "InfoBox",
	props: [
		"label", //string
		"value", //string, number
		"stacked", //if true, label will appear above value, centered
		"dark"
	]
}
</script>

<style type="text/css" scoped>
	.card {
		margin: 0;
	}

	.card.dark {
		background-color: var(--background-light);
	}

	.card-body {
		padding: 0px;
		padding-bottom: 1px;
		padding-left: 8px;
		padding-right: 8px;
		text-align: center;
		margin-top: -1px;
	}

	.card-body.stacked {
		text-align: center;
	}

	.stacked label {
		display: block;
	}

	label {
		padding: 0;
		margin: 0;
		margin-right: 5px;
		font-size: 11pt;
		text-transform: uppercase;
	}

	span.value {
		font-weight: bold;
		font-size: 14pt;
	}
</style>